import {axiosAPI} from "./axiosClient"


export const FolderService = {

  getFolders() {
    return axiosAPI.get(`/user/grantedfolders`)
  },

}